export default "__VITE_ASSET__CXBk9$IG__"